module.exports = __webpack_public_path__ + "static/media/CAM_H_08.1ebd8f7d.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/clothes/faces/CAM_H_08.png
// module id = 158
// module chunks = 0